/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Transcript_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Transcript import failed: {error}" |
*
* @param {Iframe_Remote_Transcript_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_transcript_import_failed_toast = /** @type {((inputs: Iframe_Remote_Transcript_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Transcript_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'import de la transcription : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Transkriptimport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione della trascrizione non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт стенограммы не удался: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la importación de la transcripción: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`成绩单导入失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`トランスクリプトのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रतिलेख आयात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação da transcrição falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Transcript import failed: ${i?.error}`)
});